import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Whether someone born on `birthdate` has reached `age` by `referenceDate`
// (e.g. is at least 18 years old at the start of an event).
export function hasReachedAge(birthdate: Date | string, age: number, referenceDate: Date): boolean {
  const cutoff = new Date(birthdate);
  cutoff.setFullYear(cutoff.getFullYear() + age);
  return cutoff <= referenceDate;
}

export const dateWithoutTimezone = (date: Date) => {
  const tzoffset = date.getTimezoneOffset() * 60000;
  const withoutTimezone = new Date(date.valueOf() - tzoffset).toISOString().slice(0, -1);
  return withoutTimezone;
};

function collectImageUrls(node: any, out: Set<string>) {
  if (node?.type === "image" && typeof node.src === "string") out.add(node.src);
  if (Array.isArray(node?.children)) node.children.forEach((c: any) => collectImageUrls(c, out));
}

export function extractEditorImageUrls(content: string): string[] {
  try {
    const state = JSON.parse(content);
    const urls = new Set<string>();
    collectImageUrls(state?.root, urls);
    return Array.from(urls);
  } catch {
    return [];
  }
}
